import { DashboardOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { APP_PREFIX_PATH } from "configs/AppConfig";
import {
  BrokerIcon,
  ClientData,
  Dashboard,
  Document,
  LeadReport,
  ManageLocation,
  ManageProperty,
  SalesPipeline,
  SignedAgreements,
  Users,
  Analytics
} from "assets/svg/sideNavigation/navigationicon";

const extraNavTree1 = [
  {
    key: "extra",
    path: `${APP_PREFIX_PATH}/pages`,
    title: " ",
    icon: PlusCircleOutlined,
    breadcrumb: false,
    submenu: [
      {
        key: "home",
        path: `${APP_PREFIX_PATH}/home__new`,
        title: "home",
        icon: Dashboard,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "manage-broker",
        path: `${APP_PREFIX_PATH}/manage-broker`,
        title: "Manage Broker",
        icon: BrokerIcon,
        breadcrumb: false,
        submenu: [],
      },

      {
        key: "manage-user",
        path: `${APP_PREFIX_PATH}/manage-user`,
        title: "Manage User",
        icon: Users,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "manage-roles",
        path: `${APP_PREFIX_PATH}/manage-roles`,
        title: "Manage Roles",
        icon: Users,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "master-suite",
        path: `${APP_PREFIX_PATH}/master-suite`,
        title: "Master Suite",
        icon: ManageProperty,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "property",
        path: `${APP_PREFIX_PATH}/property`,
        title: "Manage Property",
        icon: ManageProperty,
        breadcrumb: true,
        submenu: [
          {
            key: "property-LOI",
            path: `${APP_PREFIX_PATH}/property/property-LOI`,
            title: "Property LOI",
            icon: "",
            breadcrumb: false,
            submenu: [],
          },
          {
            key: "property-owner",
            path: `${APP_PREFIX_PATH}/property/property-owner`,
            title: "Property Owner",
            icon: "",
            breadcrumb: false,
            submenu: [],
          },
          {
            key: "propertyAgreements",
            path: `${APP_PREFIX_PATH}/property/propertyAgreements`,
            title: "Property Agreements",
            icon: "",
            breadcrumb: false,
            submenu: [],
          },
          {
            key: "manage-Location",
            path: `${APP_PREFIX_PATH}/manage-location`,
            title: "Manage Location",
            icon: "",
            breadcrumb: false,
            submenu: [],
          },
        ],
      },
      {
        key: "client",
        path: `${APP_PREFIX_PATH}/client`,
        title: "Client Data",
        icon: ClientData,
        breadcrumb: true,
        submenu: [
          {
            key: "create-client",
            path: `${APP_PREFIX_PATH}/client/create-client`,
            title: "Create Client",
            icon: "",
            breadcrumb: false,
            submenu: [],
          },
          {
            key: "update-create-gst",
            path: `${APP_PREFIX_PATH}/client/update-create-gst`,
            title: "Update Company Details",
            icon: "",
            breadcrumb: false,
            submenu: [],
          },
          {
            key: "client-agreement-report",
            path: `${APP_PREFIX_PATH}/client/client-agreement-report`,
            title: "Client Agreement Report",
            icon: "",
            breadcrumb: false,
            submenu: [],
          },
          {
            key: "change-company-name",
            path: `${APP_PREFIX_PATH}/client/change-company-name`,
            title: "Change Company Name",
            icon: "",
            breadcrumb: false,
            submenu: [],
          },
          {
            key: "client-spoc-details",
            path: `${APP_PREFIX_PATH}/client/client-spoc-details`,
            title: "Client Spoc Details",
            icon: "",
            breadcrumb: false,
            submenu: [],
          },
          {
            key: "client-exit-checklist",
            path: `${APP_PREFIX_PATH}/client/client-exit-checklist`,
            title: "Client Exit Checklist",
            icon: "",
            breadcrumb: false,
            submenu: [],
          },
          {
            key: "client-exit-listing",
            path: `${APP_PREFIX_PATH}/client/client-exit-listing`,
            title: "Client Exit Listing",
            icon: "",
            breadcrumb: false,
            submenu: [],
          },
          {
            key: "create-new-account",
            path: `${APP_PREFIX_PATH}/client/create-new-account`,
            title: "Create New Account",
            icon: "",
            breadcrumb: false,
            submenu: [],
          },
        ],
      },
      {
        key: "lead",
        path: `${APP_PREFIX_PATH}/lead`,
        title: "Lead Report",
        icon: LeadReport,
        breadcrumb: true,
        submenu: [
          {
            key: "leadreportmanagement",
            path: `${APP_PREFIX_PATH}/lead/leadreportmanagement`,
            title: "Lead Management Report",
            icon: "",
            breadcrumb: false,
            submenu: [],
          },
          {
            key: "leadreportmodified",
            path: `${APP_PREFIX_PATH}/lead/leadreportmodified`,
            title: "Lead Recent Modified Report",
            icon: "",
            breadcrumb: false,
            submenu: [],
          },
        ],
      },
      {
        key: "marketing",
        path: `${APP_PREFIX_PATH}/marketing`,
        title: "Marketing",
        icon: LeadReport,
        breadcrumb: true,
        submenu: [
          {
            key: "marketing-lead-list",
            path: `${APP_PREFIX_PATH}/marketing/lead-list`,
            title: "Lead List",
            icon: "",
            breadcrumb: false,
            submenu: [],
          },
        ],
      },
      {
        key: "salespipeline",
        path: `${APP_PREFIX_PATH}/salespipeline`,
        title: "Sales Pipeline",
        icon: SalesPipeline,
        breadcrumb: true,
        submenu: [
          {
            key: "smartproposal",
            path: `${APP_PREFIX_PATH}/salespipeline/smartproposal`,
            title: "Smart Proposal",
            icon: "",
            breadcrumb: false,
            submenu: [],
          },
          {
            key: "leads",
            path: `${APP_PREFIX_PATH}/salespipeline/leads`,
            title: "Leads ",
            icon: "",
            breadcrumb: false,
            submenu: [],
          },
        ],
      },
      {
        key: "document",
        path: `${APP_PREFIX_PATH}/document`,
        title: "Document",
        icon: Document,
        breadcrumb: true,
        submenu: [
          {
            key: "agreement-documents",
            path: `${APP_PREFIX_PATH}/document/agreement-documents`,
            title: "Agreement Documents",
            icon: "",
            breadcrumb: false,
            submenu: [],
          },
          {
            key: "upload-signed-agreement",
            path: `${APP_PREFIX_PATH}/document/upload-signed-agreement`,
            title: "Upload Signed Agreement ",
            icon: "",
            breadcrumb: false,
            submenu: [],
          },
        ],
      },
      {
        key: "signedagreement",
        path: `${APP_PREFIX_PATH}/signedagreement`,
        title: "Signed Agreement",
        icon: SignedAgreements,
        breadcrumb: true,
        submenu: [
          {
            key: "agreement-list",
            path: `${APP_PREFIX_PATH}/signedagreement/agreement-list`,
            title: "Agreement List",
            icon: "",
            breadcrumb: false,
            submenu: [],
          },
        ],
      },
    ],
  },
];
const extraNavTree = [
  {
    key: "extra",
    path: `${APP_PREFIX_PATH}/pages`,
    title: " ",
    icon: PlusCircleOutlined,
    breadcrumb: false,
    submenu: [
      {
        key: "home",
        path: `${APP_PREFIX_PATH}/home_new`,
        title: "home",
        icon: Dashboard,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "manage-broker",
        path: `${APP_PREFIX_PATH}/manage-broker`,
        title: "Manage Broker",
        icon: BrokerIcon,
        breadcrumb: false,
        submenu: [],
      },

      {
        key: "manage-user",
        path: `${APP_PREFIX_PATH}/manage-user`,
        title: "Manage User",
        icon: Users,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "manage-roles",
        path: `${APP_PREFIX_PATH}/manage-roles`,
        title: "Manage Roles",
        icon: Users,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "master-suite",
        path: `${APP_PREFIX_PATH}/master-suite`,
        title: "Master Suite",
        icon: ManageProperty,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "property",
        path: `${APP_PREFIX_PATH}/property`,
        title: "Manage Property",
        icon: ManageProperty,
        breadcrumb: true,
        submenu: [
          {
            key: "property-LOI",
            path: `${APP_PREFIX_PATH}/property/property-LOI`,
            title: "Property LOI",
            icon: "",
            breadcrumb: false,
            submenu: [],
          },
          {
            key: "property-owner",
            path: `${APP_PREFIX_PATH}/property/property-owner`,
            title: "Property Owner",
            icon: "",
            breadcrumb: false,
            submenu: [],
          },
          {
            key: "propertyAgreements",
            path: `${APP_PREFIX_PATH}/property/propertyAgreements`,
            title: "Property Agreements",
            icon: "",
            breadcrumb: false,
            submenu: [],
          },
          {
            key: "manage-Location",
            path: `${APP_PREFIX_PATH}/manage-location`,
            title: "Manage Location",
            icon: "",
            breadcrumb: false,
            submenu: [],
          },
        ],
      },
      {
        key: "client",
        path: `${APP_PREFIX_PATH}/client`,
        title: "Client Data",
        icon: ClientData,
        breadcrumb: true,
        submenu: [
          {
            key: "create-client",
            path: `${APP_PREFIX_PATH}/client/create-client`,
            title: "Create Client",
            icon: "",
            breadcrumb: false,
            submenu: [],
          },
          {
            key: "update-create-gst",
            path: `${APP_PREFIX_PATH}/client/update-create-gst`,
            title: "Update Company Details",
            icon: "",
            breadcrumb: false,
            submenu: [],
          },
          {
            key: "client-agreement-report",
            path: `${APP_PREFIX_PATH}/client/client-agreement-report`,
            title: "Client Agreement Report",
            icon: "",
            breadcrumb: false,
            submenu: [],
          },
          {
            key: "change-company-name",
            path: `${APP_PREFIX_PATH}/client/change-company-name`,
            title: "Change Company Name",
            icon: "",
            breadcrumb: false,
            submenu: [],
          },
          {
            key: "client-spoc-details",
            path: `${APP_PREFIX_PATH}/client/client-spoc-details`,
            title: "Client Spoc Details",
            icon: "",
            breadcrumb: false,
            submenu: [],
          },
          {
            key: "client-exit-checklist",
            path: `${APP_PREFIX_PATH}/client/client-exit-checklist`,
            title: "Client Exit Checklist",
            icon: "",
            breadcrumb: false,
            submenu: [],
          },
          {
            key: "client-exit-listing",
            path: `${APP_PREFIX_PATH}/client/client-exit-listing`,
            title: "Client Exit Listing",
            icon: "",
            breadcrumb: false,
            submenu: [],
          },
          {
            key: "create-new-account",
            path: `${APP_PREFIX_PATH}/client/create-new-account`,
            title: "Create New Account",
            icon: "",
            breadcrumb: false,
            submenu: [],
          },
          {
            key: "manage-tds-client",
            path: `${APP_PREFIX_PATH}/client/manage-tds-client`,
            title: "Manage TDS Client",
            icon: "",
            breadcrumb: false,
            submenu: [],
          },


        ],
      },
      {
        key: "lead",
        path: `${APP_PREFIX_PATH}/lead`,
        title: "Lead Report",
        icon: LeadReport,
        breadcrumb: true,
        submenu: [
          {
            key: "leadreportmanagement",
            path: `${APP_PREFIX_PATH}/lead/leadreportmanagement`,
            title: "Lead Management Report ",
            icon: "",
            breadcrumb: false,
            submenu: [],
          },
          {
            key: "leadreportmodified",
            path: `${APP_PREFIX_PATH}/lead/leadreportmodified`,
            title: "Lead Modified Report",
            icon: "",
            breadcrumb: false,
            submenu: [],
          },
        ],
      },
      {
        key: "marketing",
        path: `${APP_PREFIX_PATH}/marketing`,
        title: "Marketing",
        icon: LeadReport,
        breadcrumb: true,
        submenu: [
          {
            key: "marketing-lead-list",
            path: `${APP_PREFIX_PATH}/marketing/lead-list`,
            title: "Lead List",
            icon: "",
            breadcrumb: false,
            submenu: [],
          },
        ],
      },
      {
        key: "salespipeline",
        path: `${APP_PREFIX_PATH}/salespipeline`,
        title: "Sales Pipeline",
        icon: SalesPipeline,
        breadcrumb: true,
        submenu: [
          {
            key: "smartproposal",
            path: `${APP_PREFIX_PATH}/salespipeline/smartproposal`,
            title: "Smart Proposal",
            icon: "",
            breadcrumb: false,
            submenu: [],
          },
          {
            key: "leads",
            path: `${APP_PREFIX_PATH}/salespipeline/leads`,
            title: "Leads ",
            icon: "",
            breadcrumb: false,
            submenu: [],
          },
        ],
      },
      {
        key: "document",
        path: `${APP_PREFIX_PATH}/document`,
        title: "Document",
        icon: Document,
        breadcrumb: true,
        submenu: [
          {
            key: "agreement-documents",
            path: `${APP_PREFIX_PATH}/document/agreement-documents`,
            title: "Agreement Documents",
            icon: "",
            breadcrumb: false,
            submenu: [],
          },
          {
            key: "upload-signed-agreement",
            path: `${APP_PREFIX_PATH}/document/upload-signed-agreement`,
            title: "Upload Signed Agreement ",
            icon: "",
            breadcrumb: false,
            submenu: [],
          },
        ],
      },
      {
        key: "signedagreement",
        path: `${APP_PREFIX_PATH}/signedagreement`,
        title: "Signed Agreement",
        icon: SignedAgreements,
        breadcrumb: true,
        submenu: [
          {
            key: "agreement-list",
            path: `${APP_PREFIX_PATH}/signedagreement/agreement-list`,
            title: "Agreement List",
            icon: "",
            breadcrumb: false,
            submenu: [],
          },
        ],
      },
      {
        key: "occupancy-tracker",
        path: `${APP_PREFIX_PATH}/occupancy-tracker`,
        title: "Occupancy Tracker",
        icon: PlusCircleOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "office-booking",
        path: `${APP_PREFIX_PATH}/office-booking`,
        title: "Office Booking",
        icon: PlusCircleOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "kycstatus",
        path: `${APP_PREFIX_PATH}/kycstatus`,
        title: "KYC status",
        icon: PlusCircleOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "analytics",
        path: `${APP_PREFIX_PATH}/analytics`,
        title: "Analytics",
        icon: Analytics,
        breadcrumb: false,
        submenu: [],
      },
    ],
  },
];

const navigationConfig = [...extraNavTree];

export default navigationConfig;
